import {Directive, ElementRef, inject, Input, OnInit, Renderer2} from '@angular/core';
import {AccessGradeControlsService} from './access-controls.service';


@Directive({
  selector: '[pasAccessRole]',
  standalone: true,
})
export class AccessRoleDirective implements OnInit {
  @Input() pasAccessRole?: AccessableControlKeys;
  @Input() blockator?: boolean;

  _mode: 'view' | 'edit' = 'view'
  @Input() set mode(v: 'view' | 'edit') {
    this._mode = v;
    if (this._rights && v) this.setPermission()
  };

  get mode(): 'view' | 'edit' {
    return this._mode;
  }

  private _rights: ControlRights | null = null

  elementRef: ElementRef = inject(ElementRef);
  renderer: Renderer2 = inject(Renderer2)
  accessService: AccessGradeControlsService = inject(AccessGradeControlsService)

  setElementHidden() {
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
  }

  setElementVisible() {
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', '');
  }

  setElementDisabled() {
    this.renderer.setAttribute(this.elementRef.nativeElement, 'data-enabled', 'false');
  }

  setElementEditable() {
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', '');
    this.renderer.setAttribute(this.elementRef.nativeElement, 'data-enabled', 'true')
  }

  setElementVisibleAndEditable() {
    this.setElementVisible();
    this.setElementEditable();
  }

  setElementVisibleButDisabled() {
    this.setElementVisible();
    this.setElementDisabled();
  }


  setPermission(): void {
    if (!this.pasAccessRole || !this._rights) return;
    const permissionButtons: boolean = this._rights[this._mode][this.pasAccessRole];

    if (this.elementRef.nativeElement instanceof HTMLButtonElement || this.elementRef.nativeElement.role === 'img') {
      if (permissionButtons) {
        this.blockator !== undefined && this.blockator !== null
          ? (this.blockator ? this.setElementVisibleAndEditable() : this.setElementVisibleButDisabled())
          : this.setElementVisibleAndEditable()
      } else {
        this.setElementHidden()
      }
    } else {
      if (this.mode === 'view') {
        if (this.pasAccessRole === 'org_facility_indices'
          || this.pasAccessRole === 'indicator_indices'
          || this.pasAccessRole === 'index_comment'
          || this.pasAccessRole === 'enter_data'
        ) return this.setOrgFacilityIndicesInView();

        const permissions = this.blockator !== undefined && this.blockator !== null
          ? this.blockator && this._rights['view'][this.pasAccessRole]
          : this._rights['view'][this.pasAccessRole];
        this.setElementDisabled();
        permissions ? this.setElementDisabled() : this.setElementHidden();
      }

      if (this.mode === 'edit') {
        if (this.pasAccessRole === 'org_facility_indices'
          || this.pasAccessRole === 'indicator_indices'
          || this.pasAccessRole === 'index_comment'
          || this.pasAccessRole === 'enter_data'
        ) return this.setOrgFacilityIndicesInEdit();

        const permissionsView = this._rights['view'][this.pasAccessRole]
        const permissionsEdit = this.blockator !== undefined && this.blockator !== null
          ? this.blockator && this._rights['edit'][this.pasAccessRole]
          : this._rights['edit'][this.pasAccessRole]

        if (!permissionsView) {
          this.setElementHidden();
        } else {
          this.setElementVisible();
          permissionsEdit ? this.setElementEditable() : this.setElementDisabled();
        }
      }

    }
  }

  private setOrgFacilityIndicesInView() {
    if (!this._rights || !this.pasAccessRole) return;

    // проверяем только режим view
    const permissionOrgFacilityIndices = this._rights['view']['org_facility_indices']

    if (this.pasAccessRole === 'org_facility_indices') {
      permissionOrgFacilityIndices ? this.setElementVisibleAndEditable() : this.setElementHidden();
    }
    if (this.pasAccessRole === 'indicator_indices') {
      permissionOrgFacilityIndices ? this.setElementVisibleAndEditable() : this.setElementHidden();
    }
    if (this.pasAccessRole === 'index_comment' || this.pasAccessRole === 'enter_data') {
      permissionOrgFacilityIndices ? this.setElementVisibleButDisabled() : this.setElementHidden();
    }

  }

  private setOrgFacilityIndicesInEdit() {
    if (!this._rights || !this.pasAccessRole) return;

    // проверяем только режим edit
    const permissionOrgFacilityIndices = this._rights['edit']['org_facility_indices']

    if (this.pasAccessRole === 'org_facility_indices') {
      this.setElementVisibleAndEditable();
    }
    if (this.pasAccessRole === 'indicator_indices') {
      this.setElementVisibleAndEditable();
    }
    if (this.pasAccessRole === 'index_comment' || this.pasAccessRole === 'enter_data') {
      permissionOrgFacilityIndices ? this.setElementVisibleAndEditable() : this.setElementVisibleButDisabled();
    }

  }

  ngOnInit(): void {
    this.accessService
      .subscribe(v => {
        this._rights = v
        this.setPermission()
      })
  }


}
